import Typography from '@material-ui/core/Typography';

import {
    WithSnackbarProps,
} from 'notistack';
import React, {
    Component,
} from 'react';
import {
    RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
    FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import Spinner from '../../components/Spinner';

import {
    languageCodes,
} from '../../constants/languages';
import {
    IBannerAdsStore,
} from '../../mobx-store/storeInterfaces/bannerAdsInterface';
import {
    AuthStore,
} from '../../mobx-store/stores/authStore';
import {NoAccessWheelStore} from '../../mobx-store/stores/noAccessWheelStore';
import classes from './addEditNoAccess.module.scss';
import {CountryStore} from "../../mobx-store/stores/countryStore";
import SnackBarComponent from "../../components/SnackBarComponent/SnackBarComponent";

interface IProps extends WithSnackbarProps {
    bannerAdsStore: IBannerAdsStore;
    countryStore: CountryStore;
    authStore: AuthStore;
    match: any;
    history: any;
}

interface IState {
    formFields: FormField[];
    loading: boolean;
    loadingManagedCountries: boolean;
    processing: boolean;
    selectedLang: string;
}

const noAccessWheelStore = new NoAccessWheelStore();

class AddEditNoAccess extends Component<IProps & RouteComponentProps, IState> {


    isLoading = false;
    schema: any;

    externalLinkFormFields: FormField[] = [];

    constructor(props: IProps & RouteComponentProps) {
        super(props);
        this.initState();
    }

    initState = (isConstructor = true) => {
        const initState: IState = {
            loadingManagedCountries: true,
            processing: false,
            loading: false,
            selectedLang: languageCodes.english,
            formFields: this.getFormFields(),
        };
        this.initCategorySchema()
        if (isConstructor) {
            this.state = initState;
        } else {
            this.setState(initState);
        }
    };

    getFormPageHeader = () => (
        <div className={classes.header}>
            <Typography className={classes.title} variant="h6" gutterBottom>
                Add No Access Wheel
            </Typography>
        </div>
    );
    getFormFields = (): FormField[] => {
        const formFields: FormField[] = [
            {
                name: 'list',
                label: 'Add List',
                type: 'text',
                multiLine: true,
                rowsMax: 6,
                filedType: 'InputField',
            },]
        return formFields
    }
    initCategorySchema = () => {
        this.schema = Yup.object().shape({
            list: Yup.string()
                .required('Required'),
        });
    };
    getSubmitButton = () => ({
        title: 'Add Rejected Wheel List',
        onSubmit: this.handleSubmit,
    });

    handleSubmit = async (values: any) => {

        const {list} = values
        this.isLoading = true
        try {
            const res = await noAccessWheelStore.AddNoAccessWheelList(list)

            if (res.status === true){
                SnackBarComponent.getInstance().openSnackbar(res.message, 5000, 'success');
                window.location.href="/no-access-wheel"
            }
            else
                SnackBarComponent.getInstance().openSnackbar(res.message, 5000, 'error');

        } catch (e) {
            SnackBarComponent.getInstance().openSnackbar('error in adding records', 5000, 'error');
        } finally {
            this.isLoading = false
        }


    };
    navigateBack = () => {
        this.props.history.push('/no-access-wheel');
    };
    getCancelButton = () => ({
        title: 'Cancel',
        onCancel: this.navigateBack,
    });

    render() {
        return (
            <div className={classes.container}>
                {this.getFormPageHeader()}
                <div className={classes.content}>
                    {this.isLoading
                        ? <Spinner/>
                        : (
                            <GeneralFormComponent
                                formTitle={'Add Rejected Wheel members List'}
                                fields={this.getFormFields()}
                                formSchema={this.schema}
                                submitButton={this.getSubmitButton()}
                                cancelButton={this.getCancelButton()}
                                processing={this.state.processing}
                                onChangeValues={(key: any, value: any) => this.onChangeValues(key, value)}
                            />
                        )}
                </div>
            </div>
        );
    }

    onChangeValues = async (key: any, value: any) => {
    };


}

export default withRouter(AddEditNoAccess);
